import { styled } from "theme/default/styled";

export const SFilterSelectSelectContainer = styled.div`
  position: relative;
`;
